export const LIST = 'LIST';
export const RESOURCES = 'RESOURCES';
export const RESOURCES_COUNT = 'RESOURCES_COUNT';

export const SET_INVOICES_LIST = 'SET_INVOICES_LIST';
export const SET_INVOICE_DATA = 'SET_INVOICE_DATA';

export const FILTER_INITIAL_DATE = 'FILTER_INITIAL_DATE';
export const FILTER_FINAL_DATE = 'FILTER_FINAL_DATE';
export const FILTER_STATUS = 'FILTER_STATUS';
export const FILTER_ORDER = 'FILTER_ORDER';

export const CURRENT_PAGE = 'CURRENT_PAGE';
export const LIMIT = 'LIMIT';
export const LOADING_DATA = 'LOADING_DATA';
export const INVOICE_ERROR_STATUS = 'INVOICE_ERROR_STATUS';
export const INVOICE_ERROR_MESSAGE = 'INVOICE_ERROR_MESSAGE';
export const NEW_INVOICE_STATUS = 'NEW_INVOICE_STATUS';
export const ORDINATION = 'ORDINATION';
export const SUBTOTAL = 'SUBTOTAL';
export const LINK = 'LINK';
export const FILTER_VISIBLE = 'FILTER_VISIBLE';
export const NEW_LINK_STATUS = 'NEW_LINK_STATUS';
export const NEW_LINK_ERROR = 'NEW_LINK_ERROR';

export const SET_SUBSCRIPTIONS_RESOURCES = 'SET_SUBSCRIPTIONS_RESOURCES';
export const SET_SUBSCRIPTIONS_RESOURCES_COUNT = 'SET_SUBSCRIPTIONS_RESOURCES_COUNT';
export const SET_SUBSCRIPTIONS_LOADING_DATA = 'SET_SUBSCRIPTIONS_LOADING_DATA';
export const SET_SUBSCRIPTIONS_CURRENT_PAGE = 'SET_SUBSCRIPTIONS_CURRENT_PAGE';
export const SET_SUBSCRIPTIONS_LIMIT = 'SET_SUBSCRIPTIONS_LIMIT';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const SUBSCRIPTION_SET = 'SUBSCRIPTION_SET';

export const SET_ELETRONIC_PAYMENTS_RESOURCES = 'SET_ELETRONIC_PAYMENTS_RESOURCES';
export const SET_ELETRONIC_PAYMENTS_RESOURCES_COUNT = 'SET_ELETRONIC_PAYMENTS_RESOURCES_COUNT';
export const SET_ELETRONIC_PAYMENTS_LOADING_DATA = 'SET_ELETRONIC_PAYMENTS_LOADING_DATA';
export const SET_ELETRONIC_PAYMENTS_CURRENT_PAGE = 'SET_ELETRONIC_PAYMENTS_CURRENT_PAGE';
export const SET_ELETRONIC_PAYMENTS_LIMIT = 'SET_ELETRONIC_PAYMENTS_LIMIT';
export const ELETRONIC_PAYMENT = 'ELETRONIC_PAYMENT';
export const NEW_ELETRONIC_PAYMENT = 'NEW_ELETRONIC_PAYMENT';
export const LOCATION = 'LOCATION';

export const SET_ELETRONIC_RECEIPTS_RESOURCES = 'SET_ELETRONIC_RECEIPTS_RESOURCES';
export const SET_ELETRONIC_RECEIPTS_RESOURCES_COUNT = 'SET_ELETRONIC_RECEIPTS_RESOURCES_COUNT';
export const SET_ELETRONIC_RECEIPTS_LOADING_DATA = 'SET_ELETRONIC_RECEIPTS_LOADING_DATA';
export const SET_ELETRONIC_RECEIPTS_CURRENT_PAGE = 'SET_ELETRONIC_RECEIPTS_CURRENT_PAGE';
export const SET_ELETRONIC_RECEIPTS_LIMIT = 'SET_ELETRONIC_RECEIPTS_LIMIT';
export const ELETRONIC_RECEIPT = 'ELETRONIC_RECEIPT';
export const NEW_ELETRONIC_RECEIPT = 'NEW_ELETRONIC_RECEIPT';
